/* eslint-disable react-hooks/exhaustive-deps */
import './index.scss';
import React, { Fragment, useState, useEffect, useRef } from 'react';
import {
  Flex,
  Icon,
  Tabs,
  NavBar,
  Button,
  ActivityIndicator,
  Toast,
  ListView,
  PullToRefresh,
} from 'antd-mobile';
import Player from 'aliplayer-react';
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.min.css';
import PdfViewer from '@/components/pdfViewer';
import {
  getBooleanValue,
  getDefaultCover,
  getUser,
  checkPermition,
  getParamBiz,
  checkLogin,
  initWs,
  isMobile,
} from '@/utils';
import { dropDown } from '@/services/saas/dict';
import { getPlayUrl, getViewUrl, info, getDownloadUrl } from '@/services/saas/res';
import { addWatchRecord } from '@/services/saas/watchRecord';
import { getComments, saveComment, getReplies } from '@/services/saas/comment';

const { teacher: defaultAvatar } = getDefaultCover();
const { watch_record_heartbeat_interval, res_play_comment_on_switch } = getParamBiz() || {};

const tabList = [
  { title: '详情', key: 'detail' },
  // { title: '相关课程', key: 'fileList' },
];

if (res_play_comment_on_switch === 'true') {
  tabList.push({ title: '评论区', key: 'comment' });
}

export { tabList };

export const skinLayout = [
  { name: 'bigPlayButton', align: 'cc', x: 30, y: 80 },
  { name: 'H5Loading', align: 'cc' },
  { name: 'infoDisplay' },
  { name: 'tooltip', align: 'blabs', x: 0, y: 56 },
  { name: 'thumbnail' },
  {
    name: 'controlBar',
    align: 'blabs',
    x: 0,
    y: 0,
    children: [
      { name: 'progress', align: 'blabs', x: 0, y: 45 },
      { name: 'playButton', align: 'tl', x: 15, y: 12 },
      { name: 'timeDisplay', align: 'tl', x: 10, y: 5 },
      { name: 'fullScreenButton', align: 'tr', x: 10, y: 12 },
      // { name: 'subtitle', align: 'tr', x: 15, y: 12 },
      // { name: 'setting', align: 'tr', x: 15, y: 12 },
      { name: 'volume', align: 'tr', x: 5, y: 10 },
      // { name: 'snapshot', align: 'tr', x: 5, y: 8 },
    ],
  },
];

export const playerConfig = (qualityChange) => ({
  width: '100%',
  height: '100%',
  autoplay: true,
  playsinline: true,
  preload: true,
  controlBarVisibility: 'hover',
  useH5Prism: true,
  skinLayout,
  components: [
    {
      name: 'QualityComponent',
      type: Player.components.QualityComponent,
      args: [
        (value) => {
          qualityChange && qualityChange(value);
        },
      ],
    },
  ],
});

export const viewerOption = {
  button: false,
  navbar: false,
  title: false,
  toolbar: false,
};

export const pullToRefreshText = {
  activate: <span>开始刷新</span>,
  deactivate: <span>已取消</span>,
  release: <span>正在刷新</span>,
  finish: <span>已完成</span>,
};

export const ListWrap = (props) => {
  return <ul>{props.children}</ul>;
};

export const ResInfo = ({ avatar, name, intro, description }) => {
  return (
    <div className="resInfo">
      <div className="author">
        <div className="author-avatar">
          <img src={avatar || defaultAvatar} alt="avatar" />
        </div>
        <div className="author-info">
          <span className="name">{name}</span>
          <div className="intro">
            {intro.map((item, index) => (
              <span key={`intro-${index}`}>{item}</span>
            ))}
          </div>
        </div>
      </div>
      <div className="description">{description}</div>
    </div>
  );
};

export const ResCommentItem = ({
  comment,
  createTime,
  id,
  realName,
  avatar,
  parentId,
  onReply,
  replayNum,
  commentInputRef,
}) => {
  const [reply, setReply] = useState([]);
  const [loading, setLoading] = useState(false);
  const [replayCount, setReplayCount] = useState();

  const showReply = async () => {
    if (parentId !== id) {
      onReply(id, queryReplay);
      commentInputRef.current.focus();
      queryReplay();
    } else {
      onReply();
    }
  };

  const queryReplay = async () => {
    setLoading(true);
    const response = await getReplies({ parentId: id, size: -1 });
    if (response.success) {
      setReply(
        response.data.records.map((item) => ({
          comment: item.comment,
          createTime: item.createTime.replace('T', ' '),
          id: item.id,
          realName: item.user.realName,
          avatar: '',
        })),
      );
      setReplayCount(response.data.records.length);
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  };

  useEffect(() => {
    if (replayNum) {
      setReplayCount(replayNum);
    }
  }, [replayNum]);

  return (
    <div className="comment-item">
      <div className="user-info">
        <div className="avatar">
          <img src={avatar || defaultAvatar} alt="avatar" />
        </div>
        <div className="info">
          <p className="user-name">{realName}</p>
          <p className="date">{createTime}</p>
        </div>
      </div>
      <div className="comment-wrapper">
        <div className="comment-content">{comment}</div>
        <div className="comment-operation">
          <em onClick={showReply}>回复({replayCount || 0})</em>
        </div>
      </div>
      {parentId === id ? (
        <div className="comment-reply">
          {loading ? (
            <div className="comment-reply-loading">
              <ActivityIndicator animating={loading} text="加载中..." />
            </div>
          ) : reply.length > 0 ? (
            reply.map((item) => (
              <div className="comment-item" key={item.id}>
                <div className="user-info">
                  <div className="avatar">
                    <img src={item.avatar || defaultAvatar} alt="avatar" />
                  </div>
                  <div className="info">
                    <p className="user-name">{item.realName}</p>
                    <p className="date">{item.createTime}</p>
                  </div>
                </div>
                <div className="comment-wrapper">
                  <div className="comment-content">{item.comment}</div>
                </div>
              </div>
            ))
          ) : (
            <div className="comment-reply-empty">暂无回复</div>
          )}
        </div>
      ) : null}
    </div>
  );
};

export const ResComment = ({ bizId }) => {
  const listRef = useRef();
  const commentInputRef = useRef();
  const storeRef = useRef({});
  const [comment, setComment] = useState({
    pagination: {
      current: 1,
      total: 0,
      size: 6,
    },
    list: [],
    loading: false,
    hasMore: true,
  });
  const { current, size } = comment.pagination;
  const [commentSource, setCommentSource] = useState(
    new ListView.DataSource({
      getRowData: (dataBlob, sectionID, rowID) => {
        return dataBlob[sectionID][rowID];
      },
      rowHasChanged: (row1, row2) => row1 !== row2,
    }),
  );
  const [draging, setDraging] = useState(false);

  const row = (rowData, sectionID, rowID) => {
    const {
      comment,
      createTime,
      id,
      user: { realName, avatar },
      parentId,
      replayNum,
    } = rowData;
    const comentItem = {
      comment,
      createTime: createTime.replace('T', ' '),
      id,
      realName,
      avatar,
      parentId,
      replayNum,
    };
    return (
      <div className="comment-row" key={rowID}>
        <ResCommentItem {...comentItem} commentInputRef={commentInputRef} onReply={onReply} />
      </div>
    );
  };

  const onEndReached = function () {
    if (!comment.loading && comment.hasMore) {
      getComment(current);
    }
  };

  const getComment = async (current) => {
    setComment((comment) => ({ ...comment, loading: true, hasMore: true }));
    const response = await getComments({ resId: bizId, current, size });
    if (response.success) {
      const { current, pages, total, size, records } = response.data;
      const hasMore = current < pages;
      const replayList = await Promise.all(
        records.map((item) => getReplies({ parentId: item.id, size: -1 })),
      );
      const replayNum = replayList
        .filter((item) => item.success)
        .map((item) => item.data.records.length);
      const recordsList = records.map((item, index) => ({
        ...item,
        replayNum: replayNum[index],
      }));
      const list = current === 1 ? recordsList : [...comment.list, ...recordsList];
      setTimeout(() => {
        setComment({
          pagination: {
            current: hasMore ? current + 1 : current,
            total,
            size,
          },
          list,
          loading: false,
          hasMore,
        });
        setCommentSource(commentSource.cloneWithRows(list));
        setDraging(false);
      }, 400);
    }
  };

  const onReply = (id, getReply) => {
    const list = comment.list.map((item) => ({
      ...item,
      parentId: id,
    }));
    setComment((state) => ({
      ...state,
      list,
    }));
    setCommentSource(commentSource.cloneWithRows(list));
    storeRef.current.parentId = id;
    storeRef.current.getReply = getReply;
  };

  const addComment = async () => {
    const commentValue = commentInputRef.current.value;
    const { userId } = getUser() || {};
    if (commentValue) {
      const commentPaylod = { comment: commentValue, userId };
      if (storeRef.current.parentId) {
        commentPaylod.parentId = storeRef.current.parentId;
      } else {
        commentPaylod.resId = bizId;
      }
      commentInputRef.current.value = '';
      const response = await saveComment(commentPaylod);
      if (response.success) {
        Toast.info('评论成功');
        if (storeRef.current.parentId) {
          storeRef.current.getReply();
        } else {
          getComment(1);
          listRef.current.scrollTo(0);
        }
      }
    }
  };

  useEffect(() => {
    getComment(1);
  }, []);

  return (
    <div className="res-comment">
      <div className="res-comment-wrap">
        <div style={{ height: '100%', overflowY: 'auto' }}>
          <ListView
            ref={listRef}
            dataSource={commentSource}
            renderFooter={() => (
              <div style={{ padding: 15, textAlign: 'center' }}>
                {comment.hasMore ? (
                  comment.loading ? (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      <ActivityIndicator animating={true} text="加载中..." />
                    </div>
                  ) : (
                    '加载完成'
                  )
                ) : (
                  '没有更多'
                )}
              </div>
            )}
            renderBodyComponent={() => <ListWrap />}
            renderRow={row}
            className="list-wrap"
            pageSize={size}
            scrollRenderAheadDistance={500}
            onEndReached={onEndReached}
            onEndReachedThreshold={10}
            pullToRefresh={
              <PullToRefresh
                refreshing={draging}
                indicator={pullToRefreshText}
                onRefresh={() => {
                  setDraging(true);
                  getComment(1);
                }}
              />
            }
          />
        </div>
      </div>
      <div className="res-comment-input">
        <input
          type="text"
          placeholder="请输入要发送的评论"
          ref={commentInputRef}
          onKeyPress={(e) => {
            if (e.nativeEvent.keyCode === 13) {
              checkLogin({
                onLogin: () => {
                  addComment();
                },
              });
            }
          }}
        />
        <em
          onClick={() => {
            checkLogin({
              onLogin: () => {
                addComment();
              },
            });
          }}
        >
          发布
        </em>
      </div>
    </div>
  );
};

const ResPlayer = ({
  match: {
    params: { id },
  },
}) => {
  const [res, setRes] = useState({ title: '', fileList: [], attr: [] });
  const { title, cover, fileList } = res;
  const [currentFile, setCurrentFile] = useState({});
  const [tab, setTab] = useState('detail');
  const [media, setMedia] = useState({});
  const { type, url, documentUrl, originalUrl } = media;
  const storeRef = useRef({
    img: document.createElement('img'),
    watchRecord: new Map([]),
    playerReady: false,
  });
  const [docViewerVisible, setDocViewerVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();

  const getResInfo = async function () {
    setLoading(true);
    const response = await info({ resId: id });
    if (response.success && response.data) {
      const {
        title,
        coverUrl,
        createrAvatar,
        createrName,
        deptName,
        resAttributeDetailList,
        intro,
        resModelVO,
      } = response.data;
      const fileList = [];
      const fileTypeMap = new Map([]);
      const respFileType = await dropDown({ code: 'file_type' });
      if (respFileType.success) {
        respFileType.data.forEach((item) => {
          fileTypeMap.set(item.value, item.text);
        });
      }
      resModelVO.resModelDetailVOList.forEach(({ resFileDetailVOList }) => {
        if (resFileDetailVOList.length > 0) {
          resFileDetailVOList.forEach((file) => {
            fileList.push({
              fileType: file.fileType,
              fileTypeName: fileTypeMap.get(file.fileType) || '',
              fileInfoId: file.fileInfoId,
              fileName: file.fileName,
              resDetailId: file.detailId,
              mbsType: file.mbsPlatformType,
            });
          });
        }
      });
      setTimeout(() => {
        setLoading(false);
      }, 300);
      setRes({
        title,
        cover: coverUrl,
        avatar: createrAvatar,
        teacher: createrName,
        dept: deptName,
        attr: resAttributeDetailList,
        description: intro,
        fileList: fileList,
      });
      if (fileList.length > 0) {
        setError(false);
        const initialFile = fileList[0];
        setCurrentFile(initialFile);
        if (['1', '5'].includes(initialFile.fileType)) {
          playMedia(initialFile);
        }
        if (initialFile.fileType === '3') {
          setMedia({ type: 'picture' });
        }
        if (['2', '4', '6'].includes(initialFile.fileType)) {
          if (initialFile.fileType === '2' && initialFile.mbsType === 'mbs') {
            setMedia({ type: 'document' });
          } else {
            setMedia({ type: 'download' });
          }
        }
      } else {
        setError({ text: '请上传文件' });
      }
    } else {
      setError({ text: response.msg || '查询资源失败' });
    }
  };

  const setMediaWrap = () => {
    if (error) {
      return (
        <div className="picture-wrap">
          <div>
            <p style={{ fontSize: '4.6vw' }}>{error.text}</p>
          </div>
        </div>
      );
    }
    if (type === 'video') {
      return url ? (
        <Player
          config={{
            ...playerConfig((quality) => {
              storeRef.current.quality = quality;
            }),
            source: url,
          }}
          onGetInstance={(instance) => {
            storeRef.current.playerIns = instance;
            instance.on('sourceloaded', (params) => {
              const paramData = params.paramData;
              const desc = paramData.desc;
              const definition = paramData.definition;
              instance.getComponent('QualityComponent').setCurrentQuality(desc, definition);
              storeRef.current.quality = desc;
            });
            instance.on('ready', () => {
              storeRef.current.playerReady = true;
            });
            instance.on('play', () => {
              addRecord(true);
              sendStart();
            });
            instance.on('pause', () => {
              stopRecord();
              sendStop();
            });
            instance.on('end', () => {
              stopRecord();
              sendStop();
            });
            instance.on('error', ({ paramData }) => {
              setError({
                text: paramData.error_msg,
              });
              stopRecord();
              sendStop();
            });
          }}
        />
      ) : null;
    }
    if (type === 'picture') {
      return (
        <div className="picture-wrap">
          <div>
            <svg t="1631787895448" viewBox="0 0 1024 1024" width="1em" height="1em">
              <path
                d="M594.944 0l335.12448 341.31968v563.2c0 65.9968-52.50048 119.48032-117.29408 119.48032H209.54624c-64.7936 0-117.2992-53.5296-117.2992-119.48032V119.48032C92.25216 53.48352 144.75776 0 209.55136 0H594.944z"
                fill="#36D2AD"
                p-id="1337"
              />
              <path
                d="M930.06848 341.31968h-211.9168c-64.74752 0-123.20768-59.48928-123.20768-125.4912V0l335.12448 341.31968z"
                fill="#FFFFFF"
                fill-opacity=".4"
                p-id="1338"
              />
              <path
                d="M613.56032 426.68032H278.4256c-10.24 0-18.61632 8.4736-18.61632 18.944V749.056c0 10.4704 8.37632 18.944 18.61632 18.944h335.1296c10.28608 0 18.61632-8.4736 18.61632-18.944V445.62432a18.80576 18.80576 0 0 0-18.61632-18.944z m-37.23776 284.39552H315.66848v-94.7712l55.8592-56.87296 93.08672 94.81216 55.8592-56.92416 55.84896 56.92416v56.87808-0.0512z m-37.23776-151.64416a37.56032 37.56032 0 0 1-37.23264-37.9392c0-20.9408 16.66048-37.93408 37.23264-37.93408 20.57728 0 37.23776 16.99328 37.23776 37.9392 0 20.9408-16.66048 37.93408-37.23776 37.93408z"
                fill="#FFFFFF"
                p-id="1339"
              />
            </svg>
            <Button
              type="primary"
              size="small"
              onClick={() => {
                showPicture(currentFile.fileInfoId);
              }}
            >
              {`预览${currentFile.fileTypeName}：${currentFile.fileName}`}
            </Button>
          </div>
        </div>
      );
    }
    if (type === 'document') {
      return (
        <div className="picture-wrap">
          <div>
            <svg t="1631787895448" viewBox="0 0 1024 1024" width="1em" height="1em">
              <path
                d="M594.944 0l335.12448 341.31968v563.2c0 65.9968-52.50048 119.48032-117.29408 119.48032H209.54624c-64.7936 0-117.2992-53.5296-117.2992-119.48032V119.48032C92.25216 53.48352 144.75776 0 209.55136 0H594.944z"
                fill="#5895FF"
                p-id="1194"
              />
              <path
                d="M930.06848 341.31968h-211.9168c-64.74752 0-123.20768-59.48928-123.20768-125.4912V0l335.12448 341.31968z"
                fill="#FFFFFF"
                fill-opacity=".4"
                p-id="1195"
              />
              <path
                d="M427.37664 725.31968V768H259.8144v-42.68032h167.56224zM594.944 640v42.68032H259.8144V640H594.944z m0-85.31968v42.63936H259.8144v-42.63936H594.944z m0-85.36064V512H259.8144v-42.68032H594.944z"
                fill="#FFFFFF"
                p-id="1196"
              />
            </svg>
            <Button
              type="primary"
              size="small"
              onClick={() => {
                showDocument(currentFile.fileInfoId);
              }}
            >
              {`预览${currentFile.fileTypeName}：${currentFile.fileName}`}
            </Button>
          </div>
        </div>
      );
    }
    if (type === 'download') {
      return (
        <div className="picture-wrap">
          <div>
            <svg t="1631787895448" viewBox="0 0 1024 1024" width="1em" height="1em">
              <path
                d="M137.90246 0.00041a48.573421 48.573421 0 0 0-35.589106 15.293433A53.964778 53.964778 0 0 0 87.0404 50.934149V968.345622a48.706541 48.706541 0 0 0 15.272954 35.640306 49.97118 49.97118 0 0 0 35.589106 15.293434h746.336982a48.639981 48.639981 0 0 0 35.589105-15.293434 50.37054 50.37054 0 0 0 15.272954-35.640306V288.717094L646.727857 0.00041H137.90246z"
                fill="#5ACC9B"
                p-id="904"
              />
              <path
                d="M935.101501 288.717094h-237.445025c-27.822069-0.6656-50.22718-23.075831-50.928619-50.93374V0.00041l288.373644 288.716684z"
                fill="#BDEBD7"
                p-id="905"
              />
              <path
                d="M499.184876 692.992132a19.046392 19.046392 0 0 0 11.888635 5.058558 16.855033 16.855033 0 0 0 11.878395-5.053438l150.93242-144.358342a7.920637 7.920637 0 0 0 1.725439-9.374716 8.232957 8.232957 0 0 0-7.633917-5.119998H578.933964V389.852414a17.341433 17.341433 0 0 0-16.998394-16.957434H460.206331a17.341433 17.341433 0 0 0-16.998393 16.957434v144.291782h-89.036764a7.439357 7.439357 0 0 0-7.639037 5.119998 9.251836 9.251836 0 0 0 1.725439 9.369596l150.9273 144.363462z m223.89751 70.487012H299.059516a16.993273 16.993273 0 0 0-15.600634 8.171517 17.044473 17.044473 0 0 0 0 17.633273 16.993273 16.993273 0 0 0 15.600634 8.171517h424.03311a17.013753 17.013753 0 0 0 15.933434-16.988154 17.013753 17.013753 0 0 0-15.933434-16.988153z"
                fill="#FFFFFF"
                p-id="906"
              />
            </svg>
            <Button
              type="primary"
              size="small"
              onClick={() => {
                downloadFile(currentFile.fileInfoId);
              }}
            >
              {`下载${currentFile.fileTypeName}：${currentFile.fileName}`}
            </Button>
          </div>
        </div>
      );
    }
  };

  const playMedia = async ({ fileType, fileInfoId, mbsType }) => {
    if (['1', '5'].includes(fileType)) {
      playVideo(fileInfoId);
    }
    if (fileType === '3') {
      showPicture(fileInfoId);
    }
    if (['2', '4', '6'].includes(fileType)) {
      if (fileType === '2' && mbsType === 'mbs') {
        showDocument(fileInfoId);
      } else {
        downloadFile(fileInfoId);
      }
    }
  };

  const playVideo = async (fileInfoId) => {
    setLoading(true);
    const responsive = await getPlayUrl({
      fileInfoId,
      playProtocol: 'hls',
    });
    if (responsive && responsive.success) {
      if (responsive.data.hls) {
        setError(false);
        const source = {};
        const originalUrl = {};
        let websocketUrl = '';
        if (
          responsive.data.hls.length > 0 &&
          responsive.data.hls[0] &&
          responsive.data.hls[0].websocketUrl
        ) {
          websocketUrl = responsive.data.hls[0].websocketUrl;
        }
        responsive.data.hls.forEach((item) => {
          source[item.resolution] = item.url;
          originalUrl[item.resolution] = item.originalUrl;
        });
        setTimeout(() => {
          setLoading(false);
        }, 300);
        setMedia((media) => ({ ...media, url: '' }));
        sendStop();
        storeRef.current.isConnect = false;
        storeRef.current.wsIns = initWs(websocketUrl, (isConnect) => {
          storeRef.current.isConnect = isConnect;
          setMedia({
            type: 'video',
            url: JSON.stringify(source),
            originalUrl,
            websocketUrl,
          });
        });
      } else {
        setError({ text: '未查询到播放信息' });
      }
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 300);
      setError({ text: responsive.msg || '查询播放信息失败' });
    }
  };

  const sendStop = () => {
    if (storeRef.current.wsIns && storeRef.current.isConnect) {
      storeRef.current.wsIns.send(
        JSON.stringify({
          jsonrpc: '2.0',
          method: 'onStop',
          params: {
            url: originalUrl[storeRef.current.quality],
          },
        }),
      );
    }
  };

  const sendStart = () => {
    if (storeRef.current.wsIns && storeRef.current.isConnect) {
      console.log(originalUrl);
      storeRef.current.wsIns.send(
        JSON.stringify({
          jsonrpc: '2.0',
          method: 'onPlay',
          params: {
            url: originalUrl[storeRef.current.quality],
          },
        }),
      );
    }
  };

  const showPicture = async (fileInfoId) => {
    setLoading(true);
    const responsive = await getViewUrl({ fileInfoId });
    if (responsive && responsive.success) {
      setError(false);
      setTimeout(() => {
        setLoading(false);
      }, 300);
      storeRef.current.img.src = responsive.data;
      if (!storeRef.current.viewerIns) {
        storeRef.current.viewerIns = new Viewer(storeRef.current.img, viewerOption);
      } else {
        storeRef.current.viewerIns.update();
      }
      storeRef.current.viewerIns.show();
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 300);
      Toast.fail(responsive.msg || '查询预览信息失败');
    }
  };

  const showDocument = async (fileInfoId) => {
    setLoading(true);
    const responsive = await getViewUrl({
      fileInfoId,
    });
    if (responsive && responsive.success) {
      setError(false);
      if (storeRef.current.playerIns) storeRef.current.playerIns.pause();
      setTimeout(() => {
        setLoading(false);
      }, 300);
      setDocViewerVisible(true);
      setMedia((media) => ({ ...media, documentUrl: '' }));
      setMedia((media) => ({ ...media, documentUrl: decodeURI(responsive.data) }));
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 300);
      Toast.fail(responsive.msg || '查询预览信息失败');
    }
  };

  const downloadFile = async (fileInfoId) => {
    if (!fileInfoId) return;
    setLoading(true);
    const responsive = await getDownloadUrl({ fileInfoId });
    if (responsive.success) {
      setTimeout(() => {
        setLoading(false);
      }, 300);
      window.open(responsive.data, '_blank');
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 300);
      Toast.fail(responsive.msg || '查询下载信息失败');
    }
  };

  const addRecord = async (startInterval) => {
    const {
      current: { watchRecord, playerIns, addRecordInerval, playerReady },
    } = storeRef;
    const { userId } = getUser() || {};
    if (!playerReady || !userId) return;
    const watchTimes = playerIns.getCurrentTime() || 0;
    const duration = playerIns.getDuration() || 0;
    const watchPercent = watchTimes / duration ? ((watchTimes / duration) * 100).toFixed(1) : 0;
    const watchId = watchRecord.get(currentFile.resDetailId);
    const param = {
      bizDetailId: currentFile.resDetailId,
      bizId: id,
      bizType: 'res',
      watchPercent,
      bizTitle: `${title}-${currentFile.fileName}`,
      bizCoverUrl: cover || undefined,
      terminalType: 'h5',
    };
    if (userId) param.userId = userId;
    if (watchId) param.watchId = watchId;
    const responsive = await addWatchRecord(param);
    if (responsive.success) {
      if (!watchId) {
        storeRef.current.watchRecord.set(currentFile.resDetailId, responsive.data);
      }
      if (startInterval) {
        if (addRecordInerval) clearInterval(addRecordInerval);
        storeRef.current.addRecordInerval = setInterval(
          () => addRecord(),
          watch_record_heartbeat_interval
            ? window.parseInt(watch_record_heartbeat_interval) * 1000
            : 60 * 1000,
        );
      }
    }
  };

  const clearRecordInterval = () => {
    storeRef.current.watchRecord.delete(currentFile.resDetailId);
    clearInterval(storeRef.current.addRecordInerval);
  };

  const stopRecord = async () => {
    clearRecordInterval();
    addRecord();
  };

  useEffect(() => {
    checkPermition(id, 'res', null, () => {
      getResInfo();
    });
    return clearRecordInterval;
  }, []);

  return (
    <div className={`resPlayer${getBooleanValue('IS_IMMERSE', false) ? ' immerse' : ''}`}>
      <NavBar mode="light" icon={<Icon type="left" />} onLeftClick={() => window.history.go(-1)}>
        <span>资源详情</span>
      </NavBar>
      <div className="player-wrap">{setMediaWrap()}</div>
      <div className="player-top">
        <h5>{title}</h5>
      </div>
      <div className="scroll-y">
        <div className="play-list">
          <p>播放列表</p>
          <div className="file-list-scroll">
            <Flex
              wrap="nowrap"
              className="file-list"
              style={{ width: `${fileList.length * 33.59}vw` }}
            >
              {fileList.map((item) => (
                <Flex.Item
                  className={`file-border ${
                    item.fileInfoId === currentFile.fileInfoId ? 'active' : ''
                  }`}
                  onClick={() => {
                    storeRef.current.playerReady = false;
                    storeRef.current.watchRecord.delete(item.detailId);
                    setCurrentFile(item);
                    playMedia(item);
                  }}
                  key={item.fileInfoId}
                >
                  <div className="file-item">
                    <span>{`${item.fileTypeName}：${item.fileName}`}</span>
                  </div>
                </Flex.Item>
              ))}
            </Flex>
          </div>
        </div>
        <Tabs
          tabs={tabList}
          tabBarPosition="top"
          page={tab}
          swipeable={false}
          useOnPan={false}
          onChange={(value) => {
            setTab(value.key);
          }}
        >
          <Fragment key="detail">
            <ResInfo
              avatar={res.avatar}
              name={res.teacher}
              intro={[res.dept, ...res.attr.map((item) => item.attributeValueName)]}
              description={res.description}
            />
          </Fragment>
          <Fragment key="comment">
            <ResComment bizId={id} />
          </Fragment>
          <Fragment key="fileList"></Fragment>
        </Tabs>
      </div>
      <div className="doc-viewer-wrap" style={docViewerVisible ? { left: 0 } : undefined}>
        <NavBar
          mode="light"
          icon={<Icon type="left" />}
          onLeftClick={() => {
            setDocViewerVisible(false);
            if (storeRef.current.playerIns) {
              storeRef.current.playerIns.play();
            }
          }}
        >
          <span>{`${currentFile.fileTypeName}：${currentFile.fileName}`}</span>
        </NavBar>
        {documentUrl ? <PdfViewer file={documentUrl} /> : null}
      </div>
      <ActivityIndicator toast text="加载中..." animating={loading} />
    </div>
  );
};

export default (props) => {
  const {
    match: {
      params: { id },
    },
  } = props;
  if (!isMobile()) {
    window.location = `${window.location.protocol}//${window.location.host}/portal/resource/resInfo/${id}`;
    return;
  }
  return <ResPlayer {...props} />;
};
